module.exports = __webpack_public_path__ + "img/aq.65448909.svg";